import { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { AsideMenu } from "../../Common/layout/aside/AsideMenu";
import { UserGroupMenu } from "../../Common/layout/aside/aside-menu-lists/UserGroupMenu";
import { Section } from "../../Common/layout/Section";
import { ContentRoute, LayoutSplashScreen } from "../../../../_metronic/layout";
import { Permissions } from "../../../util/Permissions";
import GemsOverview from "./GemsOverview";
import GemsAccruals from "./GemsAccruals";
import GemsRedemptions from "./GemsRedemptions";
import GemsCampaigns from "./GemsCampaigns";
import GemsRewardAttempts from "./GemsRewardAttempts";
import GemsAuditLogs from "./GemsAuditLogs";

const GemsPages = () => {
    return (
        <>
            <AsideMenu>
                <UserGroupMenu destination="/gems" />
            </AsideMenu>
            <Section>
                <Suspense fallback={<LayoutSplashScreen />}>
                    <Switch>
                        <Redirect exact from="/gems/:userGroup" to="/gems/:userGroup/overview" />
                        <ContentRoute
                            path="/gems/:userGroup/overview"
                            exact
                            permission={Permissions.REPORTS}
                            component={GemsOverview}
                        />
                        <ContentRoute
                            path="/gems/:userGroup/overview/accruals"
                            exact
                            permission={Permissions.REPORTS}
                            component={GemsAccruals}
                        />
                        <ContentRoute
                            path="/gems/:userGroup/overview/redemptions"
                            exact
                            permission={Permissions.REPORTS}
                            component={GemsRedemptions}
                        />
                        <ContentRoute
                            path="/gems/:userGroup/overview/campaigns"
                            exact
                            permission={Permissions.REPORTS}
                            component={GemsCampaigns}
                        />
                        <ContentRoute
                            path="/gems/:userGroup/overview/reward-attempts"
                            exact
                            permission={Permissions.REPORTS}
                            component={GemsRewardAttempts}
                        />
                        <ContentRoute
                            path="/gems/:userGroup/overview/audit-logs"
                            exact
                            permission={Permissions.REPORTS}
                            component={GemsAuditLogs}
                        />
                    </Switch>
                </Suspense>
            </Section>
        </>
    );
};

export default GemsPages;
